import React, { useState, useEffect, useMemo } from "react";

const Image = ({ src, headers = {}, alt = "", ...props }) => {
	const [imageSrc, setImageSrc] = useState(null);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(false);

	const memoizedHeaders = useMemo(() => headers, [JSON.stringify(headers)]);

	useEffect(() => {
		if (!src) return;
		
		const fetchImage = async () => {
			try {
				setLoading(true);
				setError(false);
				const response = await fetch(src, { headers: memoizedHeaders });

				if (!response.ok) throw new Error("Failed to load image");

				const blob = await response.blob();
				const objectURL = URL.createObjectURL(blob);
				setImageSrc(objectURL);
			} catch (err) {
				console.error("Error loading image:", err);
				setError(true);
			} finally {
				setLoading(false);
			}
		};

		fetchImage();

		// Cleanup object URL when component unmounts or src changes
		return () => {
			if (imageSrc) URL.revokeObjectURL(imageSrc);
		};
	}, [src, memoizedHeaders]);

	if (loading) return <div></div>;
	if (error) return <div></div>;

	return <img src={imageSrc} alt={alt} {...props} />;
};

export default Image;
